import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Root from 'react-modal-sheet';
import { faXmark } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AUDIO_PLAYER_ID } from './AudioPlayer';
import { QueueList } from './QueueList';

export const QueueContainer = ({ close }: { close: () => void }) => {
  const [contents, setContents] = useState<HTMLDivElement>();

  // Clicking outside of the audio player should close the queue
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const audioPlayerNode = document.getElementById(AUDIO_PLAYER_ID);
      const target = event.target as Element;
      if (!target || audioPlayerNode?.contains(target) || contents?.contains(target)) return;
      close();
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => document.removeEventListener('click', handleClickOutside, true);
  }, [contents, close]);

  const scrollToTop = useCallback(() => {
    if (contents) contents.scrollTo(0, 0);
  }, [contents]);

  return (
    // react-sheet styles is taking precedence so need to use important
    <Root.Container className="md!bottom-20 !bottom-0 !left-[unset] !right-0 !z-audioPlayerQueueMobile !h-full !overflow-hidden !rounded-none !rounded-t-md shadow-md md:absolute md:max-h-[64%] md:max-w-[390px]">
      <Root.Content className="!overflow-hidden">
        <div
          className="relative max-h-screen overflow-auto bg-white p-6 md:h-full md:rounded-r-md md:rounded-t-md"
          ref={r => setContents(r || undefined)}
        >
          <IconButton
            className="absolute right-5 top-5 p-[3px]"
            aria-label="Close Queue"
            onClick={close}
            icon={<FontAwesomeIcon icon={faXmark} size="lg" />}
          />
          <QueueList scrollToTop={scrollToTop} scrollParent={contents} />
        </div>
      </Root.Content>
    </Root.Container>
  );
};
